import React, { FC } from "react";
import cn from "classnames";

import classes from "./TagMark.module.scss";

export type TagMarkType = "primary" | "success" | "error";

type Props = {
	label: string;
	type: TagMarkType;
	className?: string;
};

export const TagMark: FC<Props> = ({ label, type, className }) => {
	const classNames = cn(classes["tag-mark"], className && className, classes[type]);
	return <div className={classNames}>{label}</div>;
};
